module.exports = __webpack_public_path__ + "media/images/japan/location_arrow_2-423b2588080d28b90a9c43716c6c1c52.svg";